import { render, staticRenderFns } from "./TiEventCreation.vue?vue&type=template&id=bf5e232a"
import script from "./TiEventCreation.vue?vue&type=script&lang=js"
export * from "./TiEventCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports